// import components
import styled from 'styled-components';

export const PlanningCycleDialogStyles = styled.div`
  min-width: 300px;
  min-height: 300px;

  .inline-input {
    width: 50px;
    margin: 0 10px;
    input {
      text-align: center;
    }
  }
  .padding-bottom,
  .recurrence-rule {
    padding-bottom: 20px;
  }
  .settings {
    min-width: 500px;
  }
  .summary {
    min-width: 400px;
  }
`;
